import { NgModule } from '@angular/core';
import { DragAutoScrollDirective } from './drag-auto-scroll.directive';
import { DragDirective } from './drag.directive';
import { DropDirective } from './drop.directive';

@NgModule({
  imports: [DragDirective, DropDirective, DragAutoScrollDirective],
  exports: [DragDirective, DropDirective, DragAutoScrollDirective]
})
export class DragDropModule {}
